import styles from "./index.module.scss";
interface IFormContainerProps {
  onSubmit: (data: any) => void;
  children: React.ReactNode;
}
export const FormContainer = ({ onSubmit, children }: IFormContainerProps) => {
  return (
    <form className={styles.formContainer} onSubmit={onSubmit}>
      {children}
    </form>
  );
};
